<template>
    <main class="list">
        <div class="page-header">
            <h1 class="page-header__title">Tabela zgłoszeń</h1>
            <ReportStats :reports="reports" />
        </div>

        <ReportList :reports="reports" />
    </main>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import ReportList from "../../components/reports/ReportsContainer.vue";
import ReportStats from "@/components/reports/ReportStats";

export default {
    components: { ReportList, ReportStats },
    name: "List",
    data() {
        return {
            reports: [],
        };
    },
    computed: mapGetters({
        token: "getToken",
        userData: "getUserData",
        headers: "getSecuredRequestHeader",
    }),
    methods: {
        // return true if given date is older than 21 days
        isArchivedCase(date) {
            return date ? moment().diff(date, 'days') > 21 : false;
        },

        // get all reports
        async fetchReports() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_URL}/medical-case/`, { headers: this.headers })

                this.reports = response.data.map(report => {
                    report.status = this.isArchivedCase(report.case.lastChemotherapyCycleAt) ? "CASE_ARCHIVED" : "CASE_ACTIVE";
                    return report;
                });

            } catch (error) {
                console.log(error);
            }
        },
    },

    beforeMount() {
        this.fetchReports();
    },
};
</script>
